import { Injectable } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs';

import { UserConfigService } from '../../../../services/user-config.service';

/**
 * Servicio de navegación (estado global derivado del Router).
 *
 * Responsabilidad:
 * - Detectar cambios de ruta y activar la pantalla/opción correspondiente en `UserConfigService`
 *   (ej. para breadcrumb/menú activo/pantalla actual).
 *
 * Nota:
 * - Es idempotente: se puede llamar `init()` múltiples veces sin duplicar suscripciones.
 * - Este servicio NO carga datos; solo sincroniza el estado con la URL actual.
 */
@Injectable({ providedIn: 'root' })
export class NavigationSyncService {
  private initialized = false;

  constructor(
    private readonly router: Router,
    private readonly userConfigService: UserConfigService,
  ) {}

  init(): void {
    if (this.initialized) return;
    this.initialized = true;

    // Activar estado inicial (útil cuando el menú se carga después de login).
    this.userConfigService.activateOptionMenu(this.router.url);

    // Mantener sincronizado el menú/estado del sistema con la ruta actual.
    this.router.events
      .pipe(filter((event): event is NavigationEnd => event instanceof NavigationEnd))
      .subscribe((event) => this.userConfigService.activateOptionMenu(event.urlAfterRedirects));
  }
}

